/**
 * Sistema de logging inteligente para Agustinos App
 * 
 * En desarrollo: Muestra todos los logs
 * En producción: Solo errores y warnings importantes
 */

const isDev = process.env.NODE_ENV === 'development';

// Logging para desarrollo (se elimina automáticamente en producción)
export const devLog = isDev ? console.log : () => {};
export const devInfo = isDev ? console.info : () => {};
export const devDebug = isDev ? console.debug : () => {};

// Logging que siempre se mantiene (errores críticos y warnings importantes)
export const logError = console.error;
export const logWarn = console.warn;

// Logging específico por categorías (solo en desarrollo)
export const logSantos = isDev ? (...args) => console.log('🎯 [SANTOS]', ...args) : () => {};
export const logAPI = isDev ? (...args) => console.log('🌐 [API]', ...args) : () => {};
export const logSections = isDev ? (...args) => console.log('📋 [SECTIONS]', ...args) : () => {};
export const logNavigation = isDev ? (...args) => console.log('🧭 [NAV]', ...args) : () => {};
export const logCache = isDev ? (...args) => console.log('💾 [CACHE]', ...args) : () => {};

// Helper para logs condicionales importantes (se pueden activar en producción si es necesario)
export const logImportant = (message, ...args) => {
  if (isDev || window.location.search.includes('debug=true')) {
    console.log('⚡ [IMPORTANT]', message, ...args);
  }
};

// Helper para timing de operaciones críticas
export const logTiming = (operation, startTime) => {
  if (isDev) {
    const duration = Date.now() - startTime;
    console.log(`⏱️ [TIMING] ${operation}: ${duration}ms`);
  }
};

const logger = {
  dev: devLog,
  info: devInfo,
  debug: devDebug,
  error: logError,
  warn: logWarn,
  santos: logSantos,
  api: logAPI,
  sections: logSections,
  navigation: logNavigation,
  cache: logCache,
  important: logImportant,
  timing: logTiming
};

export default logger;
